export const Mealprefrences = [
    { name: 'VEG', code: 'VEG' },
    { name: 'NON VEG', code: 'NON VEG' },
]